<template>
  <div class="totalhere">
    <div class="imageholder">
      <img src="./images/profilepic.jpeg" alt="Profile Pic Here" />
    </div>
    <div class="iconshere">
      <template v-for="(icon, index) in icons">
        <a :href="icon.link" :key="index"
          ><i :class="icon.view" class="fab fa-1x"></i
        ></a>
      </template>
    </div>
    <br />
    <Links />
  </div>
</template>
<script>
import Links from "./links.vue";
export default {
  name: "Aside",
  components: {
    Links,
  },
  data() {
    return {
      icons: [
        {
          view: "fa-github",
          link: "https://github.com/devulapallisai",
        },
        {
          view: "fa-linkedin-in",
          link:
            "https://www.linkedin.com/in/sai-prachodhan-devulapalli-4361a1216/",
        },
        {
          view: "fa-instagram",
          link: "https://www.instagram.com/saiprachodhan/",
        },
        {
          view: "fa-twitter",
          link: "https://twitter.com/PrachodhanSai",
        },
        {
          view: "fa-discord",
          link: "https://discordapp.com/users/782234695395180585",
        },
        {
          view: "fa-facebook-f",
          link: "https://www.facebook.com/devulapallisai.prachodhan/",
        },
      ],
    };
  },
  methods: {},
};
</script>

<style scoped>
.totalhere {
  position: fixed;
  width: 22vw;
  height: 100vh;
  /* overflow: hidden; */
}
.totalhere {
  background: linear-gradient(#391744, #411277, #103752);
  /* background: #040b14; */
}
.imageholder {
  width: 22vw;
  height: 22vh;
  margin-top: 2vh;
  margin-bottom: 2vh;
}
.imageholder img {
  position: relative;
  display: block;
  margin: auto;
  width: auto;
  height: 100%;
  border-radius: 50%;
  border: 1vh solid #3c1a49;
}
.fab {
  padding: 10px;
  border-radius: 50%;
  color: white;
  background: rgba(1, 36, 66, 0.781);
}
.fab:hover {
  background: white;
  color: black;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}
.iconshere {
  width: 19.5vw;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: auto;
}
@media screen and (max-width: 768px) and (max-height: 1025px) {
  .totalhere {
    /* display: none; */
    width: 65vw;
    z-index: 2000;
    height: 100vh;
    overflow-y: hidden;
  }
  .imageholder {
    width: 65vw;
    height: 18vh;
    margin-top: 2vh;
    margin-bottom: 2vh;
  }
  .imageholder img {
    /* position: relative; */
    display: block;
    margin: auto;
    width: auto;
    height: 100%;
    border-radius: 50%;
    border: 1vh solid #3c1a49;
  }
  .fab {
    padding: 10px;
    border-radius: 50%;
    color: white;
    background: rgba(1, 36, 66, 0.781);
  }
  .fab:hover {
    background: white;
    color: black;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
  }
  .iconshere {
    width: 62vw;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: auto;
  }
}
@media screen and (max-width: 300px) {
  .fab {
    font-size: 10px;
  }
}
@media screen and (max-height: 2000px) and (min-height: 1300px) and (min-width: 1000px) {
  .totalhere {
    width: 45vw;
    /* display: none; */
    z-index: 2000;
  }
  .imageholder {
    width: 45vw;
    height: 30vh;
    margin-top: 2vh;
    margin-bottom: 2vh;
  }
  .imageholder img {
    position: relative;
    display: block;
    margin: auto;
    width: auto;
    height: 100%;
    border-radius: 50%;
    border: 1vh solid #3c1a49;
  }
  .fab {
    padding: 10px;
    font-size: 30px;
    border-radius: 50%;
    color: white;
    background: rgba(1, 36, 66, 0.781);
  }
  .fab:hover {
    background: white;
    color: black;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
  }
  .iconshere {
    width: 40vw;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: auto;
  }
}
</style>
